// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lexend:wght@400;600;700;800;900&family=Inter:wght@300;400;500;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:wght@200..700);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg: #ece4ed;
  --text: #0b1220;
  --muted: #5b6b83;
  --border: #d8e0eb;
  --card: #ffffff;
  --blue: #1458ff;
  --blue2: #0f49bd;
  --shadow: 0 14px 38px rgba(15, 23, 42, 0.08);
}

.wu-page {
  --wu-type-heading: clamp(30px, 2.4vw, 38px);
  --wu-type-subheading: clamp(24px, 2vw, 32px);
  --wu-type-card-heading: 1.25rem;
  --wu-type-body: 1.0625rem;
  --wu-type-card-body: 1.0625rem;
  --wu-type-cta: 0.95rem;
  background: var(--bg);
  color: var(--text);
  font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;
}

.wu-container {
  max-width: 980px;
  margin: 0 auto;
  padding: 0 18px;
}

.wu-hero {
  background: #370b3b;
  border-radius: 16px;
  margin: 0.75rem 0;
  padding: 2.5rem 2rem;
}

.wu-hero__content {
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  gap: 2rem;
  align-items: center;
  justify-content: space-between;
}

.wu-hero__text {
  flex: 1.3;
}

.wu-hero__quote {
  margin: 0;
  font-family: Georgia, "Times New Roman", serif;
  font-style: normal;
  font-weight: 700;
  color: #fff;
  font-size: clamp(28px, 3.5vw, 46px);
  line-height: 1.25;
}

.wu-hero__subtext {
  margin: 1rem 0 0 0;
  font-family: Georgia, "Times New Roman", serif;
  font-style: italic;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.9);
  font-size: clamp(18px, 2vw, 24px);
  line-height: 1.4;
}

.wu-hero__visual {
  flex: 0.9;
  min-height: 300px;
  border-radius: 24px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  align-self: stretch;
  width: clamp(220px, 26vw, 360px);
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translateY(-12px);
}

@media (max-width: 960px) {
  .wu-hero__content {
    flex-direction: column;
    text-align: left;
  }

  .wu-hero__visual {
    width: 100%;
    min-height: 200px;
  }
}

.wu-section {
  padding: 44px 0;
  background: var(--bg);
}

.wu-section--white {
  background: var(--bg);
  padding-top: 56px;
}

.wu-section--white .wu-container {
  max-width: 1320px;
}

.wu-philosophy {
  display: grid;
  grid-template-columns: 360px 1fr;
  gap: 44px;
  align-items: start;
}

.wu-philosophy__image {
  position: relative;
  overflow: hidden;
}

.wu-philosophy__image img {
  width: 70%;
  height: 200x;
  object-fit: cover;
  display: block;
  border-radius: 0;
  margin-left: 2rem;
}

.wu-imageTag {
  display: none;
}

.wu-eyebrow {
  display: inline-flex;
  align-items: center;
  gap:12px;
  color: #370b3b;
  font-weight: 900;
  font-size: 0.9rem;
  letter-spacing: 0.14em;
}

.wu-eyebrow__line {
  width: 26px;
  height: 2px;
  background: #370b3b;
  border-radius: 999px;
  opacity: 0.9;
}

.wu-title {
  margin: 10px 0 10px;
  font-family: Lexend, Inter, system-ui, sans-serif;
  font-weight: 900;
  letter-spacing: -0.02em;
  font-size: var(--wu-type-subheading);
  line-height: 1.12;
  color:#370b3b
}

.wu-text {
  margin: 0 0 12px;
  color: #370b3b;
  font-size: var(--wu-type-body);
  line-height: 1.65;
}

.wu-quoteBox {
  position: relative;
  background: #d6c3d9;
  border: 1px solid #370b3b;
  border-radius: 12px;
  padding: 14px 16px 16px 10px;
  margin: 10px 0 12px;
  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.05);
  font-size: 20px ;
}

.wu-quoteBox__bar {
  position: absolute;
  left: 14px;
  top: 14px;
  bottom: 14px;
  width: 6px;
  background: #370b3b;
  border-radius: 999px;
}

.wu-quoteBox p {
  margin: 0;
  padding-left: 10px;
  color: #2b3a55;
  font-size: 1.125rem;
  font-style: italic;
  line-height: 1.55;
}

.wu-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  color: #370b3b;
  font-weight: 900;
  font-size: 18px;
}

.wu-link__arrow {
  font-weight: 900;
}

.wu-centerTitle {
  margin: 0;
  text-align: center;
  font-family: Lexend, Inter, system-ui, sans-serif;
  font-weight: 900;
  font-size: 25px;
  letter-spacing: -0.02em;
  line-height: 1.05;
  color: #370b3b;
}

.wu-centerSub {
  margin: 8px auto 0;
  text-align: center;
  color: #370b3b;
  font-size: 16px;
  max-width: 520px;
  line-height: 1.55;
}

.wu-what-layout {
  margin-top: 12px;
  display: grid;
  gap: 28px;
  grid-template-columns: minmax(210px, 0.65fr) minmax(0, 2.35fr);
  align-items: start;
  margin-left: -420px;
}

.wu-what-image {
  border-radius: 0;
  overflow: visible;
  position: relative;
  z-index: 3;
  margin-left: 0;
  transform: translate(70px, -140px);

}

.wu-what-image img {
  width: 160%;
  max-width: none;
  height: auto;
  min-height: 100px;
  display: block;
  margin-left: 0;
  margin-bottom: 0;
  object-fit: contain;
}

.wu-what-content {
  display: flex;
  flex-direction: column;
  margin-left: 0;
}

.wu-what-title {
  margin: 0 0 10px;
  text-align: center;
  font-family: Lexend, Inter, system-ui, sans-serif;
  font-weight: 900;
  font-size: var(--wu-type-heading);
  color: #370b3b;
  line-height: 1.1;
  margin-left: 0;
}

.wu-what-sub {
  margin: 0 0 24px;
  text-align: center;
  color: #370b3b;
  font-size: var(--wu-type-body);
  line-height: 1.6;
  margin-left: 0;
  max-width: 760px;
  align-self: center;
}

.wu-grid {
  margin-top: 26px;
  display: grid;
  grid-template-columns: repeat(4, minmax(250px, 1fr));
  gap: 16px;
}

.wu-card {
  background: #ece4ed;
  border: 1px solid rgba(55, 11, 59, 0.14);
  border-radius: 24px;
  padding: 26px 22px;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.05);
  min-height: 235px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: flex-start;
}

.wu-card__icon {
  width: 96px;
  height: 96px;
  border-radius: 999px;
  background: #d6c3d9;
  color: #370b3b;
  display: grid;
  place-items: center;
  margin-bottom: 14px;
}

.wu-card__icon .material-symbols-outlined {
  font-size: 38px;
}

.wu-card__title {
  margin: 0 0 10px;
  font-weight: 900;
  font-size: clamp(1.4rem, 1.5vw, 1.75rem);
  color:#370b3b
}

.wu-card__text {
  margin: 0;
  color: #370b3b;
  font-size: clamp(1.05rem, 1.15vw, 1.3rem);
  line-height: 1.5;
}

.wu-card:nth-child(3n + 2) {
  background: #370b3b;
  border-color: #370b3b;
  box-shadow: 0 20px 34px rgba(55, 11, 59, 0.3);
}

.wu-card:nth-child(3n + 2) .wu-card__icon {
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}

.wu-card:nth-child(3n + 2) .wu-card__title,
.wu-card:nth-child(3n + 2) .wu-card__text {
  color: #ffffff;
}

.wu-elite {
  margin-top: 34px;
  background: #ece4ed;
  border-radius: 20px;
  padding: 26px 18px 22px;
}

.wu-elite__title {
  margin: 0 0 18px;
  text-align: center;
  color: #370b3b;
  font-family: Lexend, Inter, system-ui, sans-serif;
  font-weight: 800;
  font-size: clamp(26px, 2.8vw, 42px);
}

.wu-elite__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

.wu-eliteCard {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.07), rgba(255, 255, 255, 0.03));
  border: 2px solid #370b3b;
  border-radius: 16px;
  padding: 24px 20px;
  text-align: center;
  min-height: 230px;
}

.wu-eliteCard__icon {
  width: 62px;
  height: 62px;
  margin: 0 auto 14px;
  border-radius: 50%;
  border: 2px solid #370b3b;
  display: grid;
  place-items: center;
  color: #370b3b;
}

.wu-eliteCard__icon .material-symbols-outlined {
  font-size: 31px;
}

.wu-eliteCard__title {
  margin: 0 0 10px;
  color: #370b3b;
  font-size: var(--wu-type-card-heading);
  font-weight: 800;
}

.wu-eliteCard__text {
  margin: 0;
  color: #370b3b;
  font-size: 15px;
  line-height: 1.55;
}

.wu-eliteCard__list {
  margin: 0;
  padding: 0;
  list-style: none;
  text-align: left;
}

.wu-eliteCard__item {
  position: relative;
  color: #370b3b;
  font-size: var(--wu-type-card-body);
  line-height: 1.6;
  padding-left: 22px;
  margin-bottom: 7px;
}

.wu-eliteCard__item:last-child {
  margin-bottom: 0;
  font-weight: 800;
}

.wu-eliteCard__item::before {
  content: "▶";
  position: absolute;
  left: 0;
  top: 0;
  color: #370b3b;
  font-size: 0.9rem;
  line-height: 1.8;
}

.wu-bottom {
  background: #d6c3d9;
  padding: 60px 0;
}

.wu-bottom__inner {
  text-align: center;
}

.wu-bottom__title {
  margin: 0;
  font-family: Lexend, Inter, system-ui, sans-serif;
  font-weight: 900;
  font-size: clamp(26px, 3vw, 38px);
  letter-spacing: -0.02em;
  line-height: 1.05;
  color:#370b3b
}

.wu-bottom__text {
  margin: 12px auto 0;
  max-width: 560px;
  color: #370b3b;
  font-size: var(--wu-type-body);
  line-height: 1.6;
}

.wu-actions {
  margin-top: 18px;
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

.wu-btn {
  border: none;
  cursor: pointer;
  border-radius: 8px;
  padding: 12px 16px;
  font-weight: 900;
  font-size: var(--wu-type-cta);
  transition: transform 0.15s ease, filter 0.15s ease;
}

.wu-btn:hover {
  transform: translateY(-1px);
  color: #f59e0b;
  filter: brightness(1.02);
}

.wu-btn--primary {
  background: #370b3b;
  color: #fff;
  box-shadow: 0 10px 20px rgba(15, 73, 189, 0.25);
}

.wu-btn--secondary {
  background: #fff;
  color: #370b3b;
  border: 1px solid #cfe0ff;
}

@media (max-width: 980px) {
  .wu-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .wu-elite__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .wu-philosophy {
    grid-template-columns: 1fr;
  }
  .wu-philosophy__image img {
    height: 320px;
  }
  .wu-what-layout {
    grid-template-columns: 1fr;
  }
  .wu-what-image img {
    min-height: 360px;
  }
}

@media (max-width: 640px) {
  .wu-container {
    padding: 0 16px;
  }

  .wu-section {
    padding: 34px 0;
  }

  .wu-philosophy {
    gap: 18px;
  }

  .wu-philosophy__image {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 2px;
  }

  .wu-philosophy__image img {
    width: 48%;
    height: auto;
    margin-left: 0;
  }

  .wu-philosophy__content {
    margin-top: 6px;
  }

  .wu-title {
    font-size: 24px;
    line-height: 1.18;
  }

  .wu-quoteBox {
    padding: 14px 14px 16px 18px;
  }

  .wu-quoteBox__bar {
    left: 10px;
  }

  .wu-quoteBox p {
    padding-left: 14px;
  }
}

@media (max-width: 520px) {
  .wu-grid {
    grid-template-columns: 1fr;
  }
  .wu-elite__grid {
    grid-template-columns: 1fr;
  }
  .wu-hero {
    margin: 0 0 0.75rem;
    padding: 1.5rem 1rem 1.1rem;
    border-radius: 0 0 16px 16px;
  }

  .wu-hero__content {
    gap: 0.75rem;
  }

  .wu-hero__visual {
    min-height: 150px;
    background-position: center 35%;
    transform: none;
  }
}

@media (max-width: 640px) {
  .wu-what-layout {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-left: 0;
  }

  .wu-what-image {
    margin-left: 0;
    transform: translate(0, 0);
  }

  .wu-what-image img {
    min-height: 320px;
    width: 100%;
    margin-bottom: 0;
  }

  .wu-what-content {
    margin-left: 0;
  }

  .wu-what-title,
  .wu-what-sub {
    margin-left: 0;
  }

  .wu-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .wu-card {
    width: 100%;
    min-height: 180px;
  }

  .wu-grid::-webkit-scrollbar {
    height: 6px;
  }

.wu-grid::-webkit-scrollbar-thumb {
  background: rgba(55, 11, 59, 0.4);
  border-radius: 999px;
}

}

@media (max-width: 960px) {
  .wu-hero__content {
    flex-direction: column;
    text-align: left;
  }

  .wu-hero__visual {
    width: 100%;
    min-height: 200px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/pages/WhyUnique/whyUnique.css"],"names":[],"mappings":"AAGA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,2CAA2C;EAC3C,4CAA4C;EAC5C,+BAA+B;EAC/B,yBAAyB;EACzB,8BAA8B;EAC9B,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,iFAAiF;AACnF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;EAC5B,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE;IACE,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;AACF;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,iDAAiD;EACjD,gBAAgB;EAChB,uBAAuB;EACvB,oCAAoC;EACpC,iBAAiB;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iDAAiD;EACjD,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,8DAA8D;EAC9D,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,kCAAkC;;AAEpC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iDAAiD;EACjD,gBAAgB;EAChB,iCAAiC;EACjC,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,oDAAoD;EACpD,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;EAC9C,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,wCAAwC;EACxC;AACF;;AAEA;EACE,SAAS;EACT,cAAc;EACd,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,iDAAiD;EACjD,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,yFAAyF;EACzF,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iDAAiD;EACjD,gBAAgB;EAChB,iCAAiC;EACjC,uBAAuB;EACvB,iBAAiB;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,mDAAmD;AACrD;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,mBAAmB;IACnB,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,+BAA+B;IAC/B,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;AAEF;EACE,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;;AAEA;EACE;IACE,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Lexend:wght@400;600;700;800;900&family=Inter:wght@300;400;500;600;700&display=swap\");\r\n@import url(\"https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:wght@200..700\");\r\n\r\n:root {\r\n  --bg: #ece4ed;\r\n  --text: #0b1220;\r\n  --muted: #5b6b83;\r\n  --border: #d8e0eb;\r\n  --card: #ffffff;\r\n  --blue: #1458ff;\r\n  --blue2: #0f49bd;\r\n  --shadow: 0 14px 38px rgba(15, 23, 42, 0.08);\r\n}\r\n\r\n.wu-page {\r\n  --wu-type-heading: clamp(30px, 2.4vw, 38px);\r\n  --wu-type-subheading: clamp(24px, 2vw, 32px);\r\n  --wu-type-card-heading: 1.25rem;\r\n  --wu-type-body: 1.0625rem;\r\n  --wu-type-card-body: 1.0625rem;\r\n  --wu-type-cta: 0.95rem;\r\n  background: var(--bg);\r\n  color: var(--text);\r\n  font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;\r\n}\r\n\r\n.wu-container {\r\n  max-width: 980px;\r\n  margin: 0 auto;\r\n  padding: 0 18px;\r\n}\r\n\r\n.wu-hero {\r\n  background: #370b3b;\r\n  border-radius: 16px;\r\n  margin: 0.75rem 0;\r\n  padding: 2.5rem 2rem;\r\n}\r\n\r\n.wu-hero__content {\r\n  max-width: 1100px;\r\n  margin: 0 auto;\r\n  display: flex;\r\n  gap: 2rem;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.wu-hero__text {\r\n  flex: 1.3;\r\n}\r\n\r\n.wu-hero__quote {\r\n  margin: 0;\r\n  font-family: Georgia, \"Times New Roman\", serif;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  color: #fff;\r\n  font-size: clamp(28px, 3.5vw, 46px);\r\n  line-height: 1.25;\r\n}\r\n\r\n.wu-hero__subtext {\r\n  margin: 1rem 0 0 0;\r\n  font-family: Georgia, \"Times New Roman\", serif;\r\n  font-style: italic;\r\n  font-weight: 400;\r\n  color: rgba(255, 255, 255, 0.9);\r\n  font-size: clamp(18px, 2vw, 24px);\r\n  line-height: 1.4;\r\n}\r\n\r\n.wu-hero__visual {\r\n  flex: 0.9;\r\n  min-height: 300px;\r\n  border-radius: 24px;\r\n  background-size: contain;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  align-self: stretch;\r\n  width: clamp(220px, 26vw, 360px);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transform: translateY(-12px);\r\n}\r\n\r\n@media (max-width: 960px) {\r\n  .wu-hero__content {\r\n    flex-direction: column;\r\n    text-align: left;\r\n  }\r\n\r\n  .wu-hero__visual {\r\n    width: 100%;\r\n    min-height: 200px;\r\n  }\r\n}\r\n\r\n.wu-section {\r\n  padding: 44px 0;\r\n  background: var(--bg);\r\n}\r\n\r\n.wu-section--white {\r\n  background: var(--bg);\r\n  padding-top: 56px;\r\n}\r\n\r\n.wu-section--white .wu-container {\r\n  max-width: 1320px;\r\n}\r\n\r\n.wu-philosophy {\r\n  display: grid;\r\n  grid-template-columns: 360px 1fr;\r\n  gap: 44px;\r\n  align-items: start;\r\n}\r\n\r\n.wu-philosophy__image {\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.wu-philosophy__image img {\r\n  width: 70%;\r\n  height: 200x;\r\n  object-fit: cover;\r\n  display: block;\r\n  border-radius: 0;\r\n  margin-left: 2rem;\r\n}\r\n\r\n.wu-imageTag {\r\n  display: none;\r\n}\r\n\r\n.wu-eyebrow {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap:12px;\r\n  color: #370b3b;\r\n  font-weight: 900;\r\n  font-size: 0.9rem;\r\n  letter-spacing: 0.14em;\r\n}\r\n\r\n.wu-eyebrow__line {\r\n  width: 26px;\r\n  height: 2px;\r\n  background: #370b3b;\r\n  border-radius: 999px;\r\n  opacity: 0.9;\r\n}\r\n\r\n.wu-title {\r\n  margin: 10px 0 10px;\r\n  font-family: Lexend, Inter, system-ui, sans-serif;\r\n  font-weight: 900;\r\n  letter-spacing: -0.02em;\r\n  font-size: var(--wu-type-subheading);\r\n  line-height: 1.12;\r\n  color:#370b3b\r\n}\r\n\r\n.wu-text {\r\n  margin: 0 0 12px;\r\n  color: #370b3b;\r\n  font-size: var(--wu-type-body);\r\n  line-height: 1.65;\r\n}\r\n\r\n.wu-quoteBox {\r\n  position: relative;\r\n  background: #d6c3d9;\r\n  border: 1px solid #370b3b;\r\n  border-radius: 12px;\r\n  padding: 14px 16px 16px 10px;\r\n  margin: 10px 0 12px;\r\n  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.05);\r\n  font-size: 20px ;\r\n}\r\n\r\n.wu-quoteBox__bar {\r\n  position: absolute;\r\n  left: 14px;\r\n  top: 14px;\r\n  bottom: 14px;\r\n  width: 6px;\r\n  background: #370b3b;\r\n  border-radius: 999px;\r\n}\r\n\r\n.wu-quoteBox p {\r\n  margin: 0;\r\n  padding-left: 10px;\r\n  color: #2b3a55;\r\n  font-size: 1.125rem;\r\n  font-style: italic;\r\n  line-height: 1.55;\r\n}\r\n\r\n.wu-link {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  text-decoration: none;\r\n  color: #370b3b;\r\n  font-weight: 900;\r\n  font-size: 18px;\r\n}\r\n\r\n.wu-link__arrow {\r\n  font-weight: 900;\r\n}\r\n\r\n.wu-centerTitle {\r\n  margin: 0;\r\n  text-align: center;\r\n  font-family: Lexend, Inter, system-ui, sans-serif;\r\n  font-weight: 900;\r\n  font-size: 25px;\r\n  letter-spacing: -0.02em;\r\n  line-height: 1.05;\r\n  color: #370b3b;\r\n}\r\n\r\n.wu-centerSub {\r\n  margin: 8px auto 0;\r\n  text-align: center;\r\n  color: #370b3b;\r\n  font-size: 16px;\r\n  max-width: 520px;\r\n  line-height: 1.55;\r\n}\r\n\r\n.wu-what-layout {\r\n  margin-top: 12px;\r\n  display: grid;\r\n  gap: 28px;\r\n  grid-template-columns: minmax(210px, 0.65fr) minmax(0, 2.35fr);\r\n  align-items: start;\r\n  margin-left: -420px;\r\n}\r\n\r\n.wu-what-image {\r\n  border-radius: 0;\r\n  overflow: visible;\r\n  position: relative;\r\n  z-index: 3;\r\n  margin-left: 0;\r\n  transform: translate(70px, -140px);\r\n\r\n}\r\n\r\n.wu-what-image img {\r\n  width: 160%;\r\n  max-width: none;\r\n  height: auto;\r\n  min-height: 100px;\r\n  display: block;\r\n  margin-left: 0;\r\n  margin-bottom: 0;\r\n  object-fit: contain;\r\n}\r\n\r\n.wu-what-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin-left: 0;\r\n}\r\n\r\n.wu-what-title {\r\n  margin: 0 0 10px;\r\n  text-align: center;\r\n  font-family: Lexend, Inter, system-ui, sans-serif;\r\n  font-weight: 900;\r\n  font-size: var(--wu-type-heading);\r\n  color: #370b3b;\r\n  line-height: 1.1;\r\n  margin-left: 0;\r\n}\r\n\r\n.wu-what-sub {\r\n  margin: 0 0 24px;\r\n  text-align: center;\r\n  color: #370b3b;\r\n  font-size: var(--wu-type-body);\r\n  line-height: 1.6;\r\n  margin-left: 0;\r\n  max-width: 760px;\r\n  align-self: center;\r\n}\r\n\r\n.wu-grid {\r\n  margin-top: 26px;\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(250px, 1fr));\r\n  gap: 16px;\r\n}\r\n\r\n.wu-card {\r\n  background: #ece4ed;\r\n  border: 1px solid rgba(55, 11, 59, 0.14);\r\n  border-radius: 24px;\r\n  padding: 26px 22px;\r\n  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.05);\r\n  min-height: 235px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  text-align: center;\r\n  justify-content: flex-start;\r\n}\r\n\r\n.wu-card__icon {\r\n  width: 96px;\r\n  height: 96px;\r\n  border-radius: 999px;\r\n  background: #d6c3d9;\r\n  color: #370b3b;\r\n  display: grid;\r\n  place-items: center;\r\n  margin-bottom: 14px;\r\n}\r\n\r\n.wu-card__icon .material-symbols-outlined {\r\n  font-size: 38px;\r\n}\r\n\r\n.wu-card__title {\r\n  margin: 0 0 10px;\r\n  font-weight: 900;\r\n  font-size: clamp(1.4rem, 1.5vw, 1.75rem);\r\n  color:#370b3b\r\n}\r\n\r\n.wu-card__text {\r\n  margin: 0;\r\n  color: #370b3b;\r\n  font-size: clamp(1.05rem, 1.15vw, 1.3rem);\r\n  line-height: 1.5;\r\n}\r\n\r\n.wu-card:nth-child(3n + 2) {\r\n  background: #370b3b;\r\n  border-color: #370b3b;\r\n  box-shadow: 0 20px 34px rgba(55, 11, 59, 0.3);\r\n}\r\n\r\n.wu-card:nth-child(3n + 2) .wu-card__icon {\r\n  background: rgba(255, 255, 255, 0.2);\r\n  color: #ffffff;\r\n}\r\n\r\n.wu-card:nth-child(3n + 2) .wu-card__title,\r\n.wu-card:nth-child(3n + 2) .wu-card__text {\r\n  color: #ffffff;\r\n}\r\n\r\n.wu-elite {\r\n  margin-top: 34px;\r\n  background: #ece4ed;\r\n  border-radius: 20px;\r\n  padding: 26px 18px 22px;\r\n}\r\n\r\n.wu-elite__title {\r\n  margin: 0 0 18px;\r\n  text-align: center;\r\n  color: #370b3b;\r\n  font-family: Lexend, Inter, system-ui, sans-serif;\r\n  font-weight: 800;\r\n  font-size: clamp(26px, 2.8vw, 42px);\r\n}\r\n\r\n.wu-elite__grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, minmax(0, 1fr));\r\n  gap: 16px;\r\n}\r\n\r\n.wu-eliteCard {\r\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.07), rgba(255, 255, 255, 0.03));\r\n  border: 2px solid #370b3b;\r\n  border-radius: 16px;\r\n  padding: 24px 20px;\r\n  text-align: center;\r\n  min-height: 230px;\r\n}\r\n\r\n.wu-eliteCard__icon {\r\n  width: 62px;\r\n  height: 62px;\r\n  margin: 0 auto 14px;\r\n  border-radius: 50%;\r\n  border: 2px solid #370b3b;\r\n  display: grid;\r\n  place-items: center;\r\n  color: #370b3b;\r\n}\r\n\r\n.wu-eliteCard__icon .material-symbols-outlined {\r\n  font-size: 31px;\r\n}\r\n\r\n.wu-eliteCard__title {\r\n  margin: 0 0 10px;\r\n  color: #370b3b;\r\n  font-size: var(--wu-type-card-heading);\r\n  font-weight: 800;\r\n}\r\n\r\n.wu-eliteCard__text {\r\n  margin: 0;\r\n  color: #370b3b;\r\n  font-size: 15px;\r\n  line-height: 1.55;\r\n}\r\n\r\n.wu-eliteCard__list {\r\n  margin: 0;\r\n  padding: 0;\r\n  list-style: none;\r\n  text-align: left;\r\n}\r\n\r\n.wu-eliteCard__item {\r\n  position: relative;\r\n  color: #370b3b;\r\n  font-size: var(--wu-type-card-body);\r\n  line-height: 1.6;\r\n  padding-left: 22px;\r\n  margin-bottom: 7px;\r\n}\r\n\r\n.wu-eliteCard__item:last-child {\r\n  margin-bottom: 0;\r\n  font-weight: 800;\r\n}\r\n\r\n.wu-eliteCard__item::before {\r\n  content: \"▶\";\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  color: #370b3b;\r\n  font-size: 0.9rem;\r\n  line-height: 1.8;\r\n}\r\n\r\n.wu-bottom {\r\n  background: #d6c3d9;\r\n  padding: 60px 0;\r\n}\r\n\r\n.wu-bottom__inner {\r\n  text-align: center;\r\n}\r\n\r\n.wu-bottom__title {\r\n  margin: 0;\r\n  font-family: Lexend, Inter, system-ui, sans-serif;\r\n  font-weight: 900;\r\n  font-size: clamp(26px, 3vw, 38px);\r\n  letter-spacing: -0.02em;\r\n  line-height: 1.05;\r\n  color:#370b3b\r\n}\r\n\r\n.wu-bottom__text {\r\n  margin: 12px auto 0;\r\n  max-width: 560px;\r\n  color: #370b3b;\r\n  font-size: var(--wu-type-body);\r\n  line-height: 1.6;\r\n}\r\n\r\n.wu-actions {\r\n  margin-top: 18px;\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.wu-btn {\r\n  border: none;\r\n  cursor: pointer;\r\n  border-radius: 8px;\r\n  padding: 12px 16px;\r\n  font-weight: 900;\r\n  font-size: var(--wu-type-cta);\r\n  transition: transform 0.15s ease, filter 0.15s ease;\r\n}\r\n\r\n.wu-btn:hover {\r\n  transform: translateY(-1px);\r\n  color: #f59e0b;\r\n  filter: brightness(1.02);\r\n}\r\n\r\n.wu-btn--primary {\r\n  background: #370b3b;\r\n  color: #fff;\r\n  box-shadow: 0 10px 20px rgba(15, 73, 189, 0.25);\r\n}\r\n\r\n.wu-btn--secondary {\r\n  background: #fff;\r\n  color: #370b3b;\r\n  border: 1px solid #cfe0ff;\r\n}\r\n\r\n@media (max-width: 980px) {\r\n  .wu-grid {\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  }\r\n  .wu-elite__grid {\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  }\r\n  .wu-philosophy {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  .wu-philosophy__image img {\r\n    height: 320px;\r\n  }\r\n  .wu-what-layout {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  .wu-what-image img {\r\n    min-height: 360px;\r\n  }\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .wu-container {\r\n    padding: 0 16px;\r\n  }\r\n\r\n  .wu-section {\r\n    padding: 34px 0;\r\n  }\r\n\r\n  .wu-philosophy {\r\n    gap: 18px;\r\n  }\r\n\r\n  .wu-philosophy__image {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin-bottom: 2px;\r\n  }\r\n\r\n  .wu-philosophy__image img {\r\n    width: 48%;\r\n    height: auto;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .wu-philosophy__content {\r\n    margin-top: 6px;\r\n  }\r\n\r\n  .wu-title {\r\n    font-size: 24px;\r\n    line-height: 1.18;\r\n  }\r\n\r\n  .wu-quoteBox {\r\n    padding: 14px 14px 16px 18px;\r\n  }\r\n\r\n  .wu-quoteBox__bar {\r\n    left: 10px;\r\n  }\r\n\r\n  .wu-quoteBox p {\r\n    padding-left: 14px;\r\n  }\r\n}\r\n\r\n@media (max-width: 520px) {\r\n  .wu-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  .wu-elite__grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  .wu-hero {\r\n    margin: 0 0 0.75rem;\r\n    padding: 1.5rem 1rem 1.1rem;\r\n    border-radius: 0 0 16px 16px;\r\n  }\r\n\r\n  .wu-hero__content {\r\n    gap: 0.75rem;\r\n  }\r\n\r\n  .wu-hero__visual {\r\n    min-height: 150px;\r\n    background-position: center 35%;\r\n    transform: none;\r\n  }\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .wu-what-layout {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 16px;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .wu-what-image {\r\n    margin-left: 0;\r\n    transform: translate(0, 0);\r\n  }\r\n\r\n  .wu-what-image img {\r\n    min-height: 320px;\r\n    width: 100%;\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  .wu-what-content {\r\n    margin-left: 0;\r\n  }\r\n\r\n  .wu-what-title,\r\n  .wu-what-sub {\r\n    margin-left: 0;\r\n  }\r\n\r\n  .wu-grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr;\r\n    gap: 16px;\r\n  }\r\n\r\n  .wu-card {\r\n    width: 100%;\r\n    min-height: 180px;\r\n  }\r\n\r\n  .wu-grid::-webkit-scrollbar {\r\n    height: 6px;\r\n  }\r\n\r\n.wu-grid::-webkit-scrollbar-thumb {\r\n  background: rgba(55, 11, 59, 0.4);\r\n  border-radius: 999px;\r\n}\r\n\r\n}\r\n\r\n@media (max-width: 960px) {\r\n  .wu-hero__content {\r\n    flex-direction: column;\r\n    text-align: left;\r\n  }\r\n\r\n  .wu-hero__visual {\r\n    width: 100%;\r\n    min-height: 200px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
